import React from 'react';

import './Checkbox.css';

export default function CheckBox(props) {
    return (
        <div className="checkbox-wrapper-6">
            <input className="tgl tgl-light"
                   type="checkbox"
                   {...props}
            />
            <label className="tgl-btn" htmlFor={props.id} />
        </div>
    )
}
